(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.talentfunlFilters = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

var React = _interopRequireWildcard((typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null));

var ReactDOM = _interopRequireWildcard((typeof window !== "undefined" ? window['ReactDOM'] : typeof global !== "undefined" ? global['ReactDOM'] : null));

var _talentfunlSearchBox = _interopRequireDefault((typeof window !== "undefined" ? window['TalentfunlSearchBox'] : typeof global !== "undefined" ? global['TalentfunlSearchBox'] : null));

var _talentfunlSearchkit = _interopRequireDefault((typeof window !== "undefined" ? window['talentfunlSearchkit'] : typeof global !== "undefined" ? global['talentfunlSearchkit'] : null));

var _numeral = _interopRequireDefault(require("numeral"));

require("numeral/locales/en-gb");

var _searchkit = (typeof window !== "undefined" ? window['searchkit'] : typeof global !== "undefined" ? global['searchkit'] : null);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

_numeral.default.locale('en-gb');

var search_filters_container = document.getElementById('search-filters');

if (search_filters_container) {
  // get all filter widgets from the sidebar.
  var filter_widgets = search_filters_container.getElementsByClassName('talentfunl-widget');
  var filters = []; // build Searchkit filter data for each widget.

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = filter_widgets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var filter_widget = _step.value;
      // get all widget <filter> elements to build params for Searchkit component.
      var filter_atts = filter_widget.getElementsByTagName('filter');
      var attributes = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = filter_atts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var filter_attr = _step2.value;
          attributes[filter_attr.getAttribute('data-key')] = filter_attr.getAttribute('data-value');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      filters.push({
        type: filter_widget.getElementsByTagName('widget')[0].getAttribute('data-type'),
        atts: attributes
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var translateFilterLabel = function translateFilterLabel(label) {
    if (typeof talentfunl_filter_labels[label] == 'string') {
      return talentfunl_filter_labels[label];
    }

    return label;
  };

  var _rangeFormatter = function rangeFormatter(count, format) {
    return (0, _numeral.default)(count).format(format);
  };

  var RefinementOption = function RefinementOption(props) {
    return React.createElement("div", {
      className: props.bemBlocks.option().state({
        selected: props.active
      }).mix(props.bemBlocks.container("item")),
      onClick: props.onClick
    }, React.createElement("div", {
      className: props.bemBlocks.option("text")
    }, translateFilterLabel(props.label)), React.createElement("div", {
      className: props.bemBlocks.option("count")
    }, props.count));
  }; // render each widget component.


  var TalentfunlFilters =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TalentfunlFilters, _React$Component);

    function TalentfunlFilters() {
      _classCallCheck(this, TalentfunlFilters);

      return _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlFilters).apply(this, arguments));
    }

    _createClass(TalentfunlFilters, [{
      key: "render",
      value: function render() {
        var filterComponenets = this.props.filters.map(function (filter) {
          switch (filter.type) {
            case 'RefinementListFilter':
              return React.createElement(_searchkit.RefinementListFilter, {
                size: parseInt(filter.atts.size),
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                field: filter.atts.field,
                operator: filter.atts.operator,
                itemComponent: RefinementOption
              });

            case 'AlphabeticalFilter':
              return React.createElement(TalentfunlAlphabeticalFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                field: filter.atts.field,
                type: filter.atts.type
              });

            case 'TaxonomyFilter':
              return React.createElement(TalentfunlTaxonomyFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                field: filter.atts.field,
                taxonomy: filter.atts.taxonomy,
                terms: filter.atts.terms
              });

            case 'DateFilter':
              return React.createElement(TalentfunlDateRangeFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                field: filter.atts.field
              });

            case 'DistanceFilter':
              return React.createElement(TalentfunDistanceFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                distance: filter.atts.distance,
                suffix: filter.atts.suffix
              });

            case 'KeywordsFilter':
              return React.createElement(TalentfunlKeywordsFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                fields: filter.atts.fields
              });

            case 'SearchbarFilter':
              return React.createElement(TalentfunlSearchbarFilter, {
                key: "searchbar"
              });

            case 'DynamicRangeFilter':
              return React.createElement(_searchkit.DynamicRangeFilter, {
                key: filter.atts.id,
                id: filter.atts.id,
                title: filter.atts.title,
                field: filter.atts.field,
                rangeFormatter: function rangeFormatter(count) {
                  return _rangeFormatter(count, filter.atts.format);
                }
              });
          }
        });
        return React.createElement("div", null, filterComponenets);
      }
    }]);

    return TalentfunlFilters;
  }(React.Component);

  ;
  /**
   * Checkbox Filter Talentfunl Controller
   *
   * @author author
   * @return void
   */

  var TalentfunlFilter =
  /*#__PURE__*/
  function (_React$Component2) {
    _inherits(TalentfunlFilter, _React$Component2);

    function TalentfunlFilter(props) {
      var _this;

      _classCallCheck(this, TalentfunlFilter);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlFilter).call(this, props));
      _this.state = {
        accessors: {}
      };
      _this.initialized = false;
      _this.getAccessor = _this.getAccessor.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }
    /**
     * Function returns accessor instance from Searchkit Manager
     * @param id string accessorKey
     * @return Object CheckboxFilterAccessor
     */


    _createClass(TalentfunlFilter, [{
      key: "getAccessor",
      value: function getAccessor(id) {
        var accessor = null,
            accessors = _talentfunlSearchkit.default.accessors.accessors;

        if (id && accessors) {
          for (var i = 0; i < accessors.length; i++) {
            if (accessors[i].key === id) {
              accessor = accessors[i];
              break;
            }
          }
        }

        return accessor;
      }
      /**
       * Initializes component
       * Useful for first updates
       */

    }, {
      key: "initializeComponent",
      value: function initializeComponent() {
        this.initialized = true;
      }
      /**
       * Checks if component is initialized
       * Useful for first updates
       */

    }, {
      key: "isInitialized",
      value: function isInitialized() {
        return this.initialized;
      }
    }]);

    return TalentfunlFilter;
  }(React.Component);
  /**
   * Alphabetical Filter COmponent
   * Filters results based on first letter
   *
   * @author PH
   * @since 2.0.0
   */


  var TalentfunlAlphabeticalFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter) {
    _inherits(TalentfunlAlphabeticalFilter, _TalentfunlFilter);

    function TalentfunlAlphabeticalFilter(props) {
      var _this2;

      _classCallCheck(this, TalentfunlAlphabeticalFilter);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlAlphabeticalFilter).call(this, props));
      _this2.state.currentLetter = '';
      _this2.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      _this2.changeLetter = _this2.changeLetter.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
      return _this2;
    }
    /**
     * Initializes accessors
     */


    _createClass(TalentfunlAlphabeticalFilter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initializeAccessors();
      }
      /**
       * Processes accessors after changing letter
       * With second click function removes current letter filter.
       */

    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this3 = this;

        var _processed = 0,
            _required = Object.keys(this.state.accessors).length;
        Object.keys(this.state.accessors).map(function (accessor, index) {
          var _value = null,
              _letter = accessor.replace(_this3.props.id, '');

          if (_letter === _this3.state.currentLetter) {
            if (!_this3.state.accessors[accessor].state.value || !_this3.isInitialized()) {
              _value = true;

              if (!_this3.isInitialized()) {
                _this3.initializeComponent();
              }
            } else {
              _this3.changeLetter('');
            }
          }

          _this3.state.accessors[accessor].state = _this3.state.accessors[accessor].state.setValue(_value);
          _processed++;

          if (_processed === _required) {
            _talentfunlSearchkit.default.reloadSearch();
          }
        });
      }
      /**
       * Initializes accessors
       */

    }, {
      key: "initializeAccessors",
      value: function initializeAccessors() {
        var _this4 = this;

        setTimeout(function () {
          _this4.alphabet.map(function (letter, index) {
            var key = _this4.props.id + letter;
            _this4.state.accessors[key] = _this4.getAccessor(key); // Load selected filter (useful during page refresh)

            if (_this4.state.accessors[key].state.value) {
              _this4.changeLetter(letter);
            }
          });
        }, 100);
      }
      /**
       * Changes current Letter
       */

    }, {
      key: "changeLetter",
      value: function changeLetter(letter, event) {
        this.setState({
          currentLetter: letter
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;

        return React.createElement("div", {
          key: this.props.id,
          className: 'sk-panel filter--alphabetical'
        }, React.createElement("div", {
          className: "label"
        }, this.props.title), this.alphabet.map(function (letter, index) {
          return React.createElement("div", {
            className: "single-letter " + (_this5.state.currentLetter === letter ? 'active' : ''),
            key: _this5.props.id + letter,
            onClick: function onClick(event) {
              return _this5.changeLetter(letter, event);
            }
          }, React.createElement("div", {
            className: "sl__wrap"
          }, React.createElement("span", null, letter), React.createElement("span", {
            style: {
              display: 'none'
            }
          }, React.createElement(_searchkit.CheckboxFilter, {
            id: _this5.props.id + letter,
            title: "",
            label: letter,
            filter: (0, _searchkit.MatchPhrasePrefix)(letter, _this5.props.field)
          }))));
        }));
      }
    }]);

    return TalentfunlAlphabeticalFilter;
  }(TalentfunlFilter);

  ;
  /**
   * RoleFilter Component
   *
   * @author PH
   * @since 2.0.0
   */

  var TalentfunlTaxonomyFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter2) {
    _inherits(TalentfunlTaxonomyFilter, _TalentfunlFilter2);

    function TalentfunlTaxonomyFilter(props) {
      var _this6;

      _classCallCheck(this, TalentfunlTaxonomyFilter);

      _this6 = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlTaxonomyFilter).call(this, props));

      if (props.terms) {
        _this6.terms = {
          main: [],
          grouped: []
        };
        _this6.state.currents = [];
        var raw = JSON.parse(props.terms);

        if (raw) {
          _this6.terms.main = raw.main;
          _this6.terms.grouped = raw.grouped;
        }
      }

      return _this6;
    }

    _createClass(TalentfunlTaxonomyFilter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.setAccessor();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.setResults();
      }
    }, {
      key: "setResults",
      value: function setResults() {
        var _this7 = this;

        var results = [];
        this.state.currents.map(function (term) {
          if (_this7.terms.grouped[term.id]) {
            _this7.terms.grouped[term.id].map(function (item) {
              var value = item.es[0] ? item.es[0] : item.name;
              results.push(value);
              return item;
            });
          }

          return term;
        });
        this.updateAccessor(results);

        _talentfunlSearchkit.default.reloadSearch();
      }
    }, {
      key: "setTerms",
      value: function setTerms(term) {
        var currents = this.state.currents,
            index = currents.indexOf(term);

        if (-1 === index) {
          currents.push(term);
        } else {
          currents.splice(index, 1);
        }

        this.setState({
          currents: currents
        });
      }
    }, {
      key: "setAccessor",
      value: function setAccessor() {
        this.state.accessors[this.props.id] = this.getAccessor(this.props.id);
      }
    }, {
      key: "updateAccessor",
      value: function updateAccessor(value) {
        this.state.accessors[this.props.id].state = this.state.accessors[this.props.id].state.setValue(value);
      }
    }, {
      key: "isActive",
      value: function isActive(term) {
        if (term && -1 !== this.state.currents.indexOf(term)) {
          return true;
        }

        return false;
      }
    }, {
      key: "render",
      value: function render() {
        var _this8 = this;

        return React.createElement("div", {
          className: "sk-panel filter--terms"
        }, React.createElement("div", {
          className: "sk-panel__header"
        }, this.props.title), React.createElement("div", {
          className: "sk-panel__content"
        }, React.createElement("div", {
          "data-qa": "options",
          className: "sk-item-list"
        }, this.terms.main.map(function (term) {
          return React.createElement("div", {
            className: "sk-item-list-option sk-item-list__item",
            "data-qa": "option",
            key: term.id
          }, React.createElement("input", {
            type: "checkbox",
            "data-qa": "checkbox",
            readOnly: "",
            className: "sk-item-list-option__checkbox",
            checked: _this8.isActive(term)
          }), React.createElement("div", {
            "data-qa": "label",
            className: "sk-item-list-option__text",
            onClick: function onClick(event) {
              return _this8.setTerms(term, event);
            }
          }, term.name));
        }))), React.createElement("div", {
          className: "sk-panel__hiddenn"
        }, React.createElement(_searchkit.RefinementListFilter, {
          size: 10,
          id: this.props.id,
          title: this.props.title,
          field: this.props.field,
          operator: 'OR'
        })));
      }
    }]);

    return TalentfunlTaxonomyFilter;
  }(TalentfunlFilter);

  ;
  /**
   * DateRange Component
   * Component with select input to choose specify date ranges
   *
   * @author PH
   * @since 2.0.0
   */

  var TalentfunlDateRangeFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter3) {
    _inherits(TalentfunlDateRangeFilter, _TalentfunlFilter3);

    function TalentfunlDateRangeFilter(props) {
      var _this9;

      _classCallCheck(this, TalentfunlDateRangeFilter);

      _this9 = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlDateRangeFilter).call(this, props));
      _this9.dates = ['newest', 'week', 'month'];
      _this9.state.filter = 'newest';
      _this9.state.filters = [{}, (0, _searchkit.RangeQuery)(_this9.props.field, {
        gte: 'now-168h'
      }), (0, _searchkit.RangeQuery)(_this9.props.field, {
        gte: 'now-1M',
        lt: 'now'
      })];
      _this9.initializeAccessors = _this9.initializeAccessors.bind(_assertThisInitialized(_assertThisInitialized(_this9)));
      _this9.changeDate = _this9.changeDate.bind(_assertThisInitialized(_assertThisInitialized(_this9)));
      return _this9;
    }
    /**
     * Runs functions just after mounting
     * @return void
     */


    _createClass(TalentfunlDateRangeFilter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initializeAccessors();
      }
      /**
       * Processes accessors after changing letter
       * With second click function removes current letter filter.
       */

    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this10 = this;

        var _processed = 0,
            _required = Object.keys(this.state.accessors).length;
        setTimeout(function () {
          Object.keys(_this10.state.accessors).map(function (key) {
            var _value = null;

            if (key !== 'newest' && key === _this10.state.filter) {
              _value = true;
            }

            _this10.state.accessors[key].state = _this10.state.accessors[key].state.setValue(_value);
            _processed++;

            if (_processed === _required) {
              _talentfunlSearchkit.default.reloadSearch();
            }
          });
        }, 100);
      }
      /**
       * Initializes component accessors
       * @return void
       */

    }, {
      key: "initializeAccessors",
      value: function initializeAccessors() {
        var _this11 = this;

        setTimeout(function () {
          _this11.dates.map(function (date, index) {
            _this11.state.accessors[date] = _this11.getAccessor(date); // Load selected filter (useful during page refresh)

            if (_this11.state.accessors[date].state.value) {
              _this11.changeDate({
                target: {
                  value: date
                }
              });
            }
          });
        }, 100);
      }
      /**
       * Changes results based on date range
       * @param event Object Event Object
       */

    }, {
      key: "changeDate",
      value: function changeDate(event) {
        this.setState({
          filter: event.target.value
        });
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement("div", {
          className: 'sk-panel filter--daterange'
        }, React.createElement("div", {
          className: "label"
        }, this.props.title), React.createElement("select", {
          onChange: this.changeDate,
          style: {
            width: '100%'
          },
          value: this.state.filter
        }, React.createElement("option", {
          value: "newest",
          defaultValue: this.state.filter === 'newest'
        }, "Newest"), React.createElement("option", {
          value: "week",
          defaultValue: this.state.filter === 'week'
        }, "This week"), React.createElement("option", {
          value: "month",
          defaultValue: this.state.filter === 'month'
        }, "This month")), React.createElement("div", {
          style: {
            display: 'none'
          }
        }, React.createElement(_searchkit.CheckboxFilter, {
          id: "newest",
          key: "dateCreated.$date-newest",
          title: "",
          label: "Newest",
          filter: this.state.filters[0]
        }), React.createElement(_searchkit.CheckboxFilter, {
          id: "week",
          key: "dateCreated.$date-week",
          title: "",
          label: "This Week",
          filter: this.state.filters[1]
        }), React.createElement(_searchkit.CheckboxFilter, {
          id: "month",
          key: "dateCreated.$date-month",
          title: "",
          label: "This Month",
          filter: this.state.filters[2]
        })));
      }
    }]);

    return TalentfunlDateRangeFilter;
  }(TalentfunlFilter);

  ;
  /**
   * Component: Distance Filter
   *
   * @author PH
   * @since 2.0.0
   */

  var TalentfunDistanceFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter4) {
    _inherits(TalentfunDistanceFilter, _TalentfunlFilter4);

    function TalentfunDistanceFilter(props) {
      var _this12;

      _classCallCheck(this, TalentfunDistanceFilter);

      _this12 = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunDistanceFilter).call(this, props));

      if (props.distance) {
        _talentfunlSearchkit.default.setQueryProcessor(function (plainQueryObject) {
          _this12.forceUpdate();

          return plainQueryObject;
        });

        _this12.locationAccessor = _this12.getAccessor('location');

        if (_this12.locationAccessor) {
          _this12.locationValue = _this12.locationAccessor.state.value;
          _this12.setDistance = _this12.setDistance.bind(_assertThisInitialized(_assertThisInitialized(_this12)));
          _this12.distances = props.distance.split(',');
          _this12.distance = null;

          if (_this12.distances) {
            _this12.distances = _this12.distances.map(function (value) {
              return {
                id: value + _this12.props.suffix,
                label: value + ' ' + _this12.props.suffix
              };
            });
          }
        }
      }

      return _this12;
    }

    _createClass(TalentfunDistanceFilter, [{
      key: "setDistance",
      value: function setDistance(event) {
        var _distance = event.target.value;
        setTimeout(function () {
          window.searchParams.distance = _distance;

          _talentfunlSearchkit.default.reloadSearch();
        }, 100);
      }
    }, {
      key: "render",
      value: function render() {
        if (this.locationValue) {
          return React.createElement("div", {
            className: "sk-panel filter--terms"
          }, React.createElement("div", {
            className: "sk-panel__header"
          }, this.props.title), React.createElement("div", {
            className: "sk-panel__content"
          }, React.createElement("select", {
            name: this.props.id,
            id: this.props.id,
            onChange: this.setDistance
          }, this.distances.map(function (distance) {
            return React.createElement("option", {
              value: distance.id,
              key: distance.id
            }, distance.label);
          }))));
        } else {
          return null;
        }
      }
    }]);

    return TalentfunDistanceFilter;
  }(TalentfunlFilter);

  ;
  /**
   * Component: Keywords
   *
   * @author PH
   * @since 2.0.0
   */

  var TalentfunlKeywordsFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter5) {
    _inherits(TalentfunlKeywordsFilter, _TalentfunlFilter5);

    function TalentfunlKeywordsFilter(props) {
      var _this13;

      _classCallCheck(this, TalentfunlKeywordsFilter);

      _this13 = _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlKeywordsFilter).call(this, props));
      _this13.fields = _this13.props.fields.split(',');
      return _this13;
    }

    _createClass(TalentfunlKeywordsFilter, [{
      key: "render",
      value: function render() {
        return React.createElement("div", null, React.createElement(_searchkit.InputFilter, {
          id: this.props.id,
          title: this.props.title,
          searchOnChange: true,
          queryFields: this.fields
        }));
      }
    }]);

    return TalentfunlKeywordsFilter;
  }(TalentfunlFilter);

  ;
  /**
   * Component: Searchbar
   *
   * @author PH
   * @since 2.0.0
   */

  var TalentfunlSearchbarFilter =
  /*#__PURE__*/
  function (_TalentfunlFilter6) {
    _inherits(TalentfunlSearchbarFilter, _TalentfunlFilter6);

    function TalentfunlSearchbarFilter(props) {
      _classCallCheck(this, TalentfunlSearchbarFilter);

      return _possibleConstructorReturn(this, _getPrototypeOf(TalentfunlSearchbarFilter).call(this, props));
    }

    _createClass(TalentfunlSearchbarFilter, [{
      key: "render",
      value: function render() {
        return React.createElement("div", {
          className: "sk-panel filter--location"
        }, React.createElement("div", {
          className: "sk-panel__content"
        }, React.createElement(_talentfunlSearchBox.default, null)));
      }
    }]);

    return TalentfunlSearchbarFilter;
  }(TalentfunlFilter);

  ;
  ReactDOM.render(React.createElement(_searchkit.SearchkitProvider, {
    searchkit: _talentfunlSearchkit.default
  }, React.createElement("div", null, React.createElement(TalentfunlFilters, {
    filters: filters
  }))), search_filters_container);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"numeral":3,"numeral/locales/en-gb":2}],2:[function(require,module,exports){
// numeral.js locale configuration
// locale : english united kingdom (uk)
// author : Dan Ristic : https://github.com/dristic

(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['../numeral'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'en-gb', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£'
        }
    });
}));

},{"../numeral":3}],3:[function(require,module,exports){
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));

},{}]},{},[1])(1)
});
